import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { BehaviorSubject, first, Subscription } from 'rxjs';
import { CountriesEnum } from 'src/common-panel/enums/countries-enum';
import { LanguagesEnum } from 'src/common-panel/enums/languages-enum';
import { UserRolesEnum } from 'src/app/common/enums/user-roles-enum';
import { ClinicListItem } from 'src/app/common/models/users-data/clinic-list-item.model';
import { EntOfficeListItem } from 'src/app/common/models/users-data/ent-office-list-item.model';
import { ClinicService } from 'src/app/services/clinic.service';
import { DialogsManagerService } from 'src/app/services/dialogs-manager.service';
import { EntOfficeService } from 'src/app/services/ent-office.service';
import { UserManageService } from 'src/app/services/user-manage.service';
import { ServerValueInterpreterService } from 'src/common-panel/services/server-value-interpreter.service';
import { UtilsService } from 'src/common-panel/services/utils.service';
import { COUNTRIES_IDS, CountryId } from 'src/common-panel/constants/country-configs.constants';

@Component({
    selector: 'app-create-user-dialog',
    templateUrl: './create-user-dialog.component.html',
    styleUrls: ['./create-user-dialog.component.css'],
    standalone: false
})
export class CreateUserDialogComponent implements OnInit, OnDestroy
{
  subscription: Subscription = new Subscription()

  closedBySubmit = false
  selectedClinic?: string

  form: FormGroup = new FormGroup({
    role: new FormControl('', [Validators.required]),
    firstName: new FormControl('', [Validators.required,Validators.pattern("^[^<>\"'`{}()$]*$")]),
    lastName: new FormControl('', [Validators.required,Validators.pattern("^[^<>\"'`{}()$]*$")]),
    email: new FormControl('', [Validators.required, Validators.pattern("^[a-zA-Z0-9._%+-]+@[a-z0-9.-]+(\\.[a-z]{2,7})+$")]),
    country: new FormControl('', [Validators.required]),
    clinic: new FormControl({ value: '', disabled: true }),
    entOffice: new FormControl({ value: '', disabled: true }),
    language: new FormControl('', [Validators.required]),
    shopAdminAccess: new FormControl(''),
    countryShopsAccess: new FormControl(''),
    patientManagerAccess: new FormControl(''),
    advancedMode: new FormControl(''),

  })

  clinicList: ClinicListItem[] = []
  officeList: EntOfficeListItem[] = []

  CountriesEnum = CountriesEnum
  CountriesIDs = COUNTRIES_IDS
  UserRolesEnum = UserRolesEnum
  LanguagesEnum = LanguagesEnum

  isSelectClinicsButtonDiasabledSubject: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(true)

  constructor(private dialogRef: MatDialogRef<any>, private dialogsManagerService: DialogsManagerService, private userManageService: UserManageService,
    private serverValueInterpreterService: ServerValueInterpreterService, private clinicService: ClinicService, private entOfficeService: EntOfficeService) { }

  ngOnDestroy(): void
  {
    this.subscription.unsubscribe()
  }

  ngOnInit(): void
  {
    this.clinicService.defualtClinicToUpdateSubject.next(false)

    if (this.userManageService.currentClinic) this.selectedClinic = this.userManageService.currentClinic.clinicId;

    let l_sub = this.form.controls['country'].valueChanges.subscribe(l_change =>
    {
      if (this.form.controls['role'].value)
      {
        if (!this.dialogsManagerService.isGoBack)
        {
          this.userManageService.newUserClinicList = []
          this.form.controls['clinic'].setValue('')
          this.form.controls['entOffice'].setValue('')

        }
        this.dialogsManagerService.isGoBack = false



        if (!this.isEnt()) this.fillClinicList(l_change)
        if (this.isEnt()) this.fillOfficeList(l_change)
        this.form.controls['clinic'].enable()
        this.form.controls['entOffice'].enable()
        this.isSelectClinicsButtonDiasabledSubject.next(false)
      }
    })

    let l_sub1 = this.form.controls['role'].valueChanges.subscribe(() =>
    {
      if (!this.dialogsManagerService.isGoBack)
      {
        this.form.controls['shopAdminAccess'].setValue('')
        this.form.controls['countryShopsAccess'].setValue('')
        this.form.controls['patientManagerAccess'].setValue('')
      }
      if (this.form.controls['country'].value)
      {
        if (!this.dialogsManagerService.isGoBack)
        {
          this.userManageService.newUserClinicList = []
          this.form.controls['clinic'].setValue('')
          this.form.controls['entOffice'].setValue('')
        }
        this.dialogsManagerService.isGoBack = false


        if (!this.isEnt()) this.fillClinicList(this.form.controls['country'].value)
        if (this.isEnt()) this.fillOfficeList(this.form.controls['country'].value)
        this.form.controls['clinic'].enable()
        this.form.controls['entOffice'].enable()
        this.isSelectClinicsButtonDiasabledSubject.next(false)
      }
    })

    let l_sub2 = this.form.controls['clinic'].valueChanges.subscribe(l_change =>
    {

      if (l_change && l_change.clinicId)
      {
        this.userManageService.currentClinic = l_change
        if (this.userManageService.newUserClinicList.length > 0)
        {
          if (!this.userManageService.newUserClinicList.includes(l_change.clinicId)) this.userManageService.newUserClinicList.push(l_change.clinicId)
        } else
        {
          this.userManageService.newUserClinicList.push(l_change.clinicId)
        }


        if (this.selectedClinic)
        {
          this.userManageService.newUserClinicList.forEach((clinicId, index) =>
          {
            if ((this.selectedClinic != l_change.clinicId) && (clinicId == this.selectedClinic)) this.userManageService.newUserClinicList.splice(index, 1);
          });
        }
        this.selectedClinic = l_change.clinicId;
      }

    })

    let l_sub3 = this.clinicService.defualtClinicToUpdateSubject.subscribe(() =>
    {
      this.form.controls['clinic'].setValue(this.userManageService.currentClinic)
    })


    this.setValuesFromModel()

    this.dialogRef.afterClosed().subscribe(() =>
    {
      if (!this.closedBySubmit) this.userManageService.clearUser()
    })

    this.subscription.add(l_sub)
    this.subscription.add(l_sub1)
    this.subscription.add(l_sub2)
    this.subscription.add(l_sub3)

  }

  fillClinicList(countryId: CountryId)
  {
    this.clinicService.loadedClinicListSubject.next(false)
    this.clinicService.loadClinicListByCountry(countryId).pipe(first(l_loaded => l_loaded == true)).subscribe(() =>
    {
      this.clinicList = this.clinicService.clinicList;
    })
  }

  fillOfficeList(countryId: CountryId)
  {
    this.entOfficeService.loadEntOfficeListByCountry(countryId).pipe(first(l_loaded => l_loaded == true)).subscribe(() =>
    {
      this.officeList = this.entOfficeService.entOfficeList;
    })
  }

  isEnt(): boolean
  {
    if (this.form.controls['role'].value == UserRolesEnum.ent) return true
    else return false
  }

  isDal(): boolean
  {
    if (this.form.controls['role'].value == UserRolesEnum.dal) return true
    else return false
  }

  setValuesFromModel()
  {
    this.form.controls['firstName'].setValue(this.userManageService.currentUser?.firstName)
    this.form.controls['lastName'].setValue(this.userManageService.currentUser?.lastName)
    this.form.controls['email'].setValue(this.userManageService.currentUser?.email)
    this.form.controls['role'].setValue(this.userManageService.currentUser?.role)
    this.form.controls['language'].setValue(this.userManageService.currentUser?.lang)
    this.form.controls['shopAdminAccess'].setValue(this.userManageService.currentUser?.shopAdminAccess)
    this.form.controls['countryShopsAccess'].setValue(this.userManageService.currentUser?.countryShopsAccess)
    this.form.controls['patientManagerAccess'].setValue(this.userManageService.currentUser?.patientManagerAccess)

    if (this.userManageService.currentUser) this.form.controls['country'].setValue(this.userManageService.currentUser.countryId)
    if (this.userManageService.currentClinic) this.form.controls['clinic'].setValue(this.userManageService.currentClinic)
    if (this.userManageService.currentOffice) this.form.controls['entOffice'].setValue(this.userManageService.currentOffice)

  }

  showSelectClinicsDialog()
  {
    this.dialogsManagerService.showSelectClinicsDialogComponent();
  }



  onSubmit()
  {
    this.userManageService.currentUser = {
      userId: '',
      firstName: this.form.controls['firstName'].value,
      lastName: this.form.controls['lastName'].value,
      email: this.form.controls['email'].value,
      role: this.form.controls['role'].value,
      status: undefined,
      statusDate: null,
      lang: this.form.controls['language'].value,
      country: this.serverValueInterpreterService.getFullCountryNameById(this.form.controls['country'].value),
      countryId: this.form.controls['country'].value,
      shopList: this.userManageService.newUserClinicList,
      clinicId: this.form.controls['clinic'].value.clinicId,
      entOfficeId: this.form.controls['entOffice'].value.entOfficeId,
      shopAdminAccess: this.form.controls['shopAdminAccess'].value,
      countryShopsAccess: this.form.controls['countryShopsAccess'].value,
      patientManagerAccess: this.form.controls['patientManagerAccess'].value,
      advancedMode:this.form.controls['advancedMode'].value,
    }
    this.userManageService.currentClinic = this.form.controls['clinic'].value
    this.userManageService.currentOffice = this.form.controls['entOffice'].value
    this.dialogsManagerService.showReviewCreateUserDialogComponent();

    this.closedBySubmit = true
    this.dialogRef.close('Excellent');
  }

  isStartsWithSubstring(text: string, substring: string): boolean
  {

    return UtilsService.isStartsWithSubstring(text, substring)
  }

  isDisabledButton(): boolean
  {
    let l_disabled = false
    if (!this.form.valid) l_disabled = true
    if ((this.form.controls['role'].value != UserRolesEnum.ent) && (this.form.controls['role'].value != UserRolesEnum.dal) && (!this.form.controls['clinic'].value || this.form.controls['clinic'].value.length < 1))
    {
      l_disabled = true
    } else if ((this.form.controls['role'].value == UserRolesEnum.ent) && this.form.controls['entOffice'].value.length < 1)
    {
      l_disabled = true
    }


    return l_disabled
  }

  getClinicsAmount(): number
  {
    return this.userManageService.newUserClinicList.length
  }

  getClinicsIds(): string
  {
    if (this.userManageService.newUserClinicList.length > 0) return this.userManageService.newUserClinicList.join(", ")
    return "No clinics selected yet"
  }

  getFullCountryNameById(countryId: CountryId): CountriesEnum
  {
    return this.serverValueInterpreterService.getFullCountryNameById(countryId)
  }
}
